import React from 'react';

export default React.createContext({activeElement: null, setFocus: () => {}});
